export const PROPERTY_TYPES = [
  { value: "apartment", label: "アパート" },
  { value: "mansion", label: "マンション" },
  { value: "house", label: "戸建" },
  { value: "shop", label: "店舗" },
  { value: "office", label: "事務所" },
  { value: "land", label: "土地" },
  { value: "parking", label: "駐車場" },
];

export const OWNERSHIP = [
  { value: "owned", label: "所有" },
  { value: "managed", label: "管理受託" },
];

export const STRUCTURES = [
  { value: "RC", label: "RC造" },
  { value: "SRC", label: "SRC造" },
  { value: "S", label: "鉄骨造" },
  { value: "木造", label: "木造" },
  { value: "その他", label: "その他" },
];

export const USE_PURPOSE = [
  { value: "居住", label: "居住用（住居）" },
  { value: "事業（事務所・店舗）", label: "事業用（事務所・店舗）" },
  { value: "駐車場", label: "駐車場" },
];

export const ROOM_STATUS = {
  occupied: { label: "入居中", tone: "green" },
  vacant: { label: "空室", tone: "gray" },
  recruiting: { label: "募集中", tone: "blue" },
  leaving: { label: "退去予定", tone: "amber" },
  repair: { label: "修繕中", tone: "red" },
};

export const CONTRACT_STATUS = {
  active: { label: "有効", tone: "green" },
  renewal: { label: "更新予定", tone: "amber" },
  terminated: { label: "終了", tone: "gray" },
};

export const INVOICE_STATUS = {
  unbilled: { label: "未請求", tone: "gray" },
  issued: { label: "請求済", tone: "blue" },
  paid: { label: "入金済", tone: "green" },
  partial: { label: "一部入金", tone: "amber" },
  unpaid: { label: "未入金", tone: "gray" },
  arrears: { label: "滞納", tone: "red" },
};

export const REPAIR_STATUS = {
  received: { label: "受付", tone: "gray" },
  checking: { label: "内容確認", tone: "blue" },
  estimate: { label: "見積", tone: "blue" },
  approved: { label: "承認", tone: "amber" },
  ordered: { label: "発注", tone: "amber" },
  in_progress: { label: "工事中", tone: "orange" },
  completed: { label: "完了", tone: "green" },
  paid: { label: "支払済", tone: "green" },
};

export const URGENCY = {
  low: { label: "低", tone: "gray" },
  medium: { label: "中", tone: "amber" },
  high: { label: "高", tone: "red" },
};

export const EXPENSE_CATEGORY = {
  loan: { label: "ローン" },
  repair: { label: "修繕" },
  management: { label: "管理費" },
  tax: { label: "固定資産税" },
  insurance: { label: "保険" },
  utility: { label: "水道光熱費" },
  other: { label: "その他経費" },
};

export const RATE_TYPE = [
  { value: "fixed", label: "固定" },
  { value: "variable", label: "変動" },
];

export const PAYMENT_METHOD = [
  { value: "bank_transfer", label: "銀行振込" },
  { value: "cash", label: "現金" },
  { value: "credit_card", label: "クレジットカード" },
  { value: "direct_debit", label: "口座振替" },
];

export const DOC_CATEGORY = [
  { value: "lease_contract", label: "賃貸借契約書" },
  { value: "registry", label: "登記簿" },
  { value: "tax_notice", label: "固定資産税通知書" },
  { value: "sales_contract", label: "売買契約書" },
  { value: "important_matters", label: "重要事項説明書" },
  { value: "estimate", label: "見積書" },
  { value: "invoice", label: "請求書" },
  { value: "repair_photo", label: "修繕写真" },
  { value: "insurance", label: "保険証券" },
  { value: "bank", label: "銀行資料" },
  { value: "other", label: "その他" },
];

export const ROLE_LABELS = {
  system_admin: "システム管理者",
  company_admin: "会社管理者",
  property_manager: "不動産管理担当",
  accountant: "経理担当",
  viewer: "閲覧ユーザー",
};

// Frontend mirror of backend write-permission matrix
export const WRITE_PERMISSIONS = {
  properties: ["company_admin", "property_manager"],
  rooms: ["company_admin", "property_manager"],
  tenants: ["company_admin", "property_manager"],
  landlords: ["company_admin", "property_manager"],
  contracts: ["company_admin", "property_manager"],
  invoices: ["company_admin", "property_manager", "accountant"],
  payments: ["company_admin", "accountant"],
  expenses: ["company_admin", "accountant"],
  loans: ["company_admin", "accountant"],
  repairs: ["company_admin", "property_manager"],
  vendors: ["company_admin", "property_manager"],
  documents: ["company_admin", "property_manager", "accountant"],
  users: ["company_admin"],
  company: ["company_admin", "property_manager", "accountant"],
};
